import { INNER_LOOP_MEASURES, INNER_LOOP_TEMPORAL_COMPARES } from '@vision/ui/constants/inner-loop-report.constant';
import { ReportFeedbackResponse, ReportFeedbackStaticResponseItem } from '@vision/ui/interfaces';
import { ReportGraphicQueryTypeMapping } from '@vision/ui/pages/ReportsDetailGraphic/constants/report-graphic-query-type-mapping';
import { getReportLocalizationKey } from '@vision/ui/utils/reports/report-localization.util';

export function localizeTicketMeasureNames(
  items: ReportFeedbackStaticResponseItem[] | null,
  translate: (key: string) => string,
): ReportFeedbackStaticResponseItem[] | null {
  return (
    items?.map((item) => {
      if (
        !INNER_LOOP_MEASURES.includes(item.measure) ||
        !Array.isArray(item.data) ||
        !item.data.every(
          (series): series is ReportFeedbackResponse => !!series && !Array.isArray(series) && 'data' in series,
        )
      ) {
        return item;
      }

      const apiMeasureName = ReportGraphicQueryTypeMapping[item.measure];
      const hasMetricOnlyComparison =
        !!item.compare && item.compare.every((compare) => INNER_LOOP_TEMPORAL_COMPARES.includes(compare));

      return {
        ...item,
        data: item.data.map((series) =>
          series.name === apiMeasureName &&
          (series.name_type === 'metric' || (series.name_type === undefined && hasMetricOnlyComparison))
            ? {
                ...series,
                name: translate(`reportMeasurementsGroupItemType.${getReportLocalizationKey(item.measure)}`),
              }
            : series,
        ),
      };
    }) ?? null
  );
}

export function getDisplayProcessItems(processItems: Array<ReportFeedbackStaticResponseItem>) {
  const nonCountOnlyProcessItems = processItems.filter((item) => !item.isCountOnly);

  if (nonCountOnlyProcessItems.length > 0) {
    return nonCountOnlyProcessItems;
  }

  return processItems.filter((item) => item.data);
}
